class OrderReceived {
    constructor(element) {
        this.element = element;

        const summary = this.element.find('[data-block-name="woocommerce/order-confirmation-summary"]');
        const licenseKeys = this.element.find('.ef-custom-license-keys');
        const stepsToInit = this.element.find('.ef-steps-to-init');

        if (summary.length && licenseKeys.length) {
            summary.prepend(stepsToInit);
            summary.prepend(licenseKeys);
        }
    }
}

const orderReceived = {
    init() {
        const elements = jQuery('body.woocommerce-order-received');

        if (elements && elements.length > 0) {
            elements.each((_, element) => {
                new OrderReceived(jQuery(element));
            });
        }
    }
};

export default orderReceived;
